// extracted by mini-css-extract-plugin
export default {"header":"TranslationsView_header__WCbJt","filters":"TranslationsView_filters__atpmA","title":"TranslationsView_title__JLoub"};